import React from 'react';
import {
  Button,
  Card,
  Col,
  ProgressBar,
  Row,
  Stack,
  Table,
} from 'react-bootstrap';
import {
  ActivityItem,
  ActivityList,
} from '../../components/dashboard/ActivityList';
import {
  StatsCard,
  StatsCardProps,
} from '../../components/dashboard/StatsCard';
import { SalesPerformanceCard } from '../../components/dashboard/SalesPerformanceCard';

const STATS: StatsCardProps[] = [
  {
    title: 'Usuários ativos',
    value: '128',
    helper: 'Últimas 24 horas',
    trend: { value: '+12%', label: 'vs. semana anterior', variant: 'success' },
  },
  {
    title: 'Conversões',
    value: '32',
    helper: 'Taxa de 18,4%',
    trend: { value: '+4%', label: 'no mês', variant: 'success' },
  },
  {
    title: 'Tickets abertos',
    value: '7',
    helper: 'Tempo médio 02h45',
    trend: { value: '-9%', label: 'desde ontem', variant: 'secondary' },
  },
];

const ACTIVITIES: ActivityItem[] = [
  {
    id: '1',
    title: 'Novo usuário cadastrado',
    description: 'Carla Freitas adicionada ao time Financeiro.',
    role: 'admin',
    timeAgo: 'há 15 minutos',
  },
  {
    id: '2',
    title: 'Plano atualizado',
    description: 'Equipe Comercial migrou para o plano Growth.',
    role: 'member',
    timeAgo: 'há 3 horas',
  },
  {
    id: '3',
    title: 'Tentativa de acesso',
    description: 'Usuário guest tentou acessar /admin/users.',
    role: 'guest',
    timeAgo: 'há 5 horas',
  },
];

const PIPELINE_STEPS = [
  { label: 'Briefing', value: 70 },
  { label: 'Design', value: 45 },
  { label: 'Desenvolvimento', value: 60 },
  { label: 'QA', value: 35 },
];

const SALES_CHANNELS = [
  { label: 'Direto', value: 45 },
  { label: 'Orgânico', value: 28 },
  { label: 'Social Ads', value: 15 },
  { label: 'Parceiros', value: 12 },
];

export const AdminDashboard: React.FC = () => (
  <Stack gap={4}>
    <div>
      <h2 className="mb-1">Visão Geral</h2>
      <p className="text-muted mb-0">
        Indicadores resumidos do ambiente administrativo. Ajuste os componentes
        para evoluir o escopo do projeto.
      </p>
    </div>

    <Row className="g-4">
      <Col lg={8}>
        <SalesPerformanceCard />
      </Col>
      <Col lg={4}>
        <Card className="shadow-sm border-0 h-100">
          <Card.Body>
            <Card.Title>Performance por canal</Card.Title>
            <Stack gap={3} className="mt-3">
              {SALES_CHANNELS.map((channel) => (
                <div key={channel.label}>
                  <div className="d-flex justify-content-between mb-1">
                    <span>{channel.label}</span>
                    <span className="text-muted">{channel.value}%</span>
                  </div>
                  <ProgressBar now={channel.value} variant="info" />
                </div>
              ))}
            </Stack>
          </Card.Body>
        </Card>
      </Col>
    </Row>

    <Row className="g-4">
      {STATS.map((stat) => (
        <Col key={stat.title} md={4}>
          <StatsCard {...stat} />
        </Col>
      ))}
    </Row>

    <Row className="g-4">
      <Col lg={8}>
        <Card className="shadow-sm border-0 h-100">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <Card.Title className="mb-1">Fluxo de Onboarding</Card.Title>
                <Card.Subtitle className="text-muted">
                  Status agregado dos times ativos.
                </Card.Subtitle>
              </div>
              <Button variant="outline-primary" size="sm">
                Ver Relatório
              </Button>
            </div>
            <Stack gap={3}>
              {PIPELINE_STEPS.map((step) => (
                <div key={step.label}>
                  <div className="d-flex justify-content-between mb-1">
                    <span>{step.label}</span>
                    <span className="text-muted">{step.value}%</span>
                  </div>
                  <ProgressBar now={step.value} />
                </div>
              ))}
            </Stack>
          </Card.Body>
        </Card>
      </Col>
      <Col lg={4}>
        <Card className="shadow-sm border-0 h-100">
          <Card.Body>
            <Card.Title>Ações rápidas</Card.Title>
            <Stack gap={2}>
              <Button variant="primary">Convidar novo usuário</Button>
              <Button variant="outline-secondary">Criar plano customizado</Button>
              <Button variant="outline-secondary">Abrir solicitação</Button>
            </Stack>
          </Card.Body>
        </Card>
      </Col>
    </Row>

    <Row className="g-4">
      <Col lg={7}>
        <Card className="shadow-sm border-0 h-100">
          <Card.Body>
            <Card.Title>Atividades recentes</Card.Title>
            <ActivityList items={ACTIVITIES} />
          </Card.Body>
        </Card>
      </Col>
      <Col lg={5}>
        <Card className="shadow-sm border-0 h-100">
          <Card.Body>
            <Card.Title>Próximas entregas</Card.Title>
            <Table responsive borderless hover className="mb-0">
              <thead>
                <tr>
                  <th>Equipe</th>
                  <th>Entrega</th>
                  <th>SLA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Marketing</td>
                  <td>Landing campanha Q4</td>
                  <td>02 dias</td>
                </tr>
                <tr>
                  <td>Produto</td>
                  <td>Release 2.8.0</td>
                  <td>05 dias</td>
                </tr>
                <tr>
                  <td>Suporte</td>
                  <td>Base de conhecimento</td>
                  <td>07 dias</td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Stack>
);
